import React, { useState, useRef, useEffect } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from 'moment';
import { formatDate } from "../../assets/helper/dateFormatter";
import { useDispatch, useSelector } from "react-redux";
import { setEndDate, setReportDates, setStartDate } from "../../redux/reducer/dateRangeSlice";
import { predefinedRanges } from "../../assets/const/dateRanges";


export default function BootstrapDateRangePicker({selectedDate}) {
    const keyRef = useRef();
    const dispatch = useDispatch();
    const dates = useSelector(state => state.dateRange.dates);
    const [startDate, setStDate] = useState(moment(dates.start));
    const [endDate, setEdDate] = useState(moment(dates.end));
    const [dateRange, setDateRange] = useState('');

    useEffect(() => {
        setSelectedDateRange(dates.startDate, dates.endDate);
    }, [])

    useEffect(() => {
        keyRef.current.setStartDate(moment(dates.start));
        keyRef.current.setEndDate(moment(dates.end));
        setSelectedDateRange(dates.start, dates.end);
        console.log("calling useEffect", (dates.start), ":", (dates.end));
    }, [dates])

    const setSelectedDateRange = (startDate, endDate) => {
        let start = formatDate(startDate);
        let end = formatDate(endDate);
        let date = start === end ? start : start + ' - ' + end;
        setStDate(startDate);
        setEdDate(endDate);
        setDateRange(date);
    }

    const handleApply = (event, picker) => {
        const selectedStart = formatDate(picker.startDate);
        const selectedEnd = formatDate(picker.endDate);
        dispatch(setReportDates({ rangeLabel:picker.chosenLabel, start: formatDate(picker.startDate), end: formatDate(picker.endDate) }));
        if (selectedDate) {
            selectedDate({
                startDate: selectedStart,
                endDate: selectedEnd
            });
        }
    };

    const handleOnHide = (e) => {
        setSelectedDateRange(moment(dates.start), moment(dates.end));
    }

    return (
        <div className="custom-daterangepicker">
            <DateRangePicker
                key={`${(dates.start)}-${(dates.end)}`}
                ref={keyRef}
                onApply={handleApply}
                onHide={handleOnHide}
                initialSettings={{
                    startDate: moment(dates.start),
                    endDate: moment(dates.end),
                    ranges: predefinedRanges,
                }}
            >
                <input
                    type="text"
                    value={dateRange}
                    readOnly
                    className="p-component form-control col-4"
                />
            </DateRangePicker>
        </div>
    );
}
;